import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';

export const SONS_SINISTRO = ['fogo1', 'fogo2', 'fogo3', 'sirene', 'submarino', 'tornado'];

export async function prepararCanaisSinistro(push = PushNotifications, device = Device): Promise<void> {
    if (Capacitor.getPlatform() !== 'android') return;
    if ((await device.getInfo()).androidSDKVersion! < 26) return;
    // O Android preserva as preferencias do usuario em canais ja criados.
    for (const som of [...SONS_SINISTRO, 'silencioso']) {
        for (const vibrar of [true, false]) {
            await push.createChannel({
                id: `SINISTRO_v2_${som}_${vibrar ? 'v1' : 'v0'}`,
                name: `Me Ajude - ${som}${vibrar ? ' (vibrar)' : ''}`,
                description: 'Pedidos de ajuda',
                importance: som === 'silencioso' ? 2 : 4,
                sound: som === 'silencioso' ? undefined : `${som}.mp3`,
                vibration: vibrar,
                visibility: 1,
                lights: true,
                lightColor: '#DA2128'
            });
        }
    }
}
